import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class pushManageState extends baseState {
	// 推送列表
	@observable list = {};
	@action
	setList = data => this.list = data;

	getList = data => {
		return this.fetch({
			url: apiUrl.PUSH_MANAGE.LIST,
			method: 'get',
			setState: "setList",
			data
		});
	}

	// 推送增删改
	insertData = data => this.fetch({ url: apiUrl.PUSH_MANAGE.CREATE, method: 'post', data }); // 创建
	update = data => this.fetch({ url: apiUrl.PUSH_MANAGE.UPDATE, method: 'post', data }); // 更新
	delete = id => this.fetch({ url: apiUrl.PUSH_MANAGE.DELETE, method: 'post', data: { ids: [id] } }); // 删除
	delete_batch = data => this.fetch({ url: apiUrl.PUSH_MANAGE.DELETE_BATCH, method: 'post', data }); // 删除

	// 用户列表无分页LIST_ALL
	@observable userList = {};
	@action
	setUserList = data => this.userList = data;

	getUserList = data => {
		return this.fetch({
			url: apiUrl.USER_MANAGE.LIST_ALL,
			method: 'get',
			setState: "setUserList",
			data
		});
	}

	// 设备列表无分页
	@observable deviceList = {};
	@action
	setDeviceList = data => this.deviceList = data;

	getDeviceList = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.LIST_ALL,
			method: 'get',
			setState: "setDeviceList",
			data
		});
	}

	// 告警日志列表
	@observable warningList = {};
	@action
	setWarnList = data => this.warningList = data;

	getWarnList = data => {
		return this.fetch({
			url: apiUrl.PUSH_MANAGE.WARN_LIST,
			method: 'get',
			setState: "setWarnList",
			data
		});
	}

	// 告警推送列表
	@observable pushList = {};
	@action
	setPushList = data => this.pushList = data;

	getPushList = data => {
		return this.fetch({
			url: apiUrl.PUSH_MANAGE.PUSH_LIST,
			method: 'get',
			setState: "setPushList",
			data
		});
	}

	// 告警推送待处理列表
	@observable waitHandleList = {};
	@action
	setWaitHandleList = data => this.waitHandleList = data;

	getWaitHandleList = data => {
		return this.fetch({
			url: apiUrl.PUSH_MANAGE.WAIT_LIST,
			method: 'get',
			setState: "setWaitHandleList",
			data
		});
	}

	// 告警处理通知
	remarkNotice = data => this.fetch({ url: apiUrl.PUSH_MANAGE.NOTICE_HANDLE, method: 'post', data }); // 单条处理

	// 批量处理告警
	batchNotice = data => this.fetch({ url: apiUrl.PUSH_MANAGE.NOTICE_HANDLE_BATCH, method: 'post', data });

}
